import { inject } from "@angular/core";
import { Router, type ResolveFn } from "@angular/router";
import { catchError, EMPTY } from "rxjs";
import { AgreementData } from "../../domain/models/agreement.model";

import { AgreementService } from "../../presentation/pages/agreement/services/agreement.service";
import { SignalService } from "../services/loader.service";
import { showNotification } from "../utils/toast";

export const agreementResolver: ResolveFn<AgreementData> = (route, state) => {
  const agreementService = inject(AgreementService);
  const loaderService = inject(SignalService);
  const router = inject(Router);
  loaderService.loadingSignal.set(true);
  const agreementType = route.url[0].path;
  const agreementId = route.params["agreementId"];
  let agreementLevel = -1;

  switch (agreementType) {
    case "opportunity":
      agreementLevel = 6;
      break;
    case "workload":
      agreementLevel = 0;
      break;
    case "proposal":
      agreementLevel = 1;
      break;
    case "prestaffing":
      agreementLevel = 2;
      break;
    case "contract":
      agreementLevel = 3;
      break;
  }

  return agreementService.loadAgreementData(agreementId, agreementLevel).pipe(
    catchError((err) => {
      loaderService.loadingSignal.set(false);
      showNotification(
        "Error while retrieving data for this agreement",
        "error",
      );
      console.log(`[AgreementResolver] Error loading agreement, redirecting to fallback`);
      // Naviga esplicitamente alla home corretta in base all'hostname
      const hostname = window.location.hostname.toLowerCase();
      if (hostname.includes('nam') || hostname.includes('rcip')) {
        router.navigate(['/home']);
      } else if (hostname.includes('smart')) {
        router.navigate(['/agenda']);
      } else {
        router.navigate(['/agenda']);
      }
      return EMPTY;
    }),
  );
};
